/* Preloader choreography — the reference's GSAP timeline ported to WAAPI
   (their loaderDuration = 2s → every phase below is 1000ms; offsets are
   their timeline positions made absolute):

     0.50s  mark fades in (their sine.in)
     1.50s  sauna flash wipes down over the mark
     1.65s  photo wipes down over the flash  ("<15%")
     1.65s  photo settles -30% → 0            ("<")
     2.65s  card wipes itself away top→down
     2.65s  photo drifts on to +10%           ("<")
     2.95s  the whole ground wipes away       ("<30%")

   The <head> guard already decided IF it runs (once per session, no reduced
   motion, storage available) and locked scroll via <html> overflow — which
   onni-lenis.js also watches, so Lenis pauses for free. Cleanup here just
   removes the gate class and the lock. A 6s failsafe means a lost `finished`
   promise can never gate the page. */
(function () {
  var html = document.documentElement;
  var root = document.querySelector('[data-preloader]');
  if (!root || !html.classList.contains('onni-preloading')) return;

  var done = false;
  var finish = function () {
    if (done) return;
    done = true;
    html.classList.remove('onni-preloading'); // display:none again via CSS
    html.style.overflow = '';
  };
  var failsafe = setTimeout(finish, 6000);

  var EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var FULL = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
  var TOP_EDGE = 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)';
  var BOTTOM_EDGE = 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)';
  var D = 1000;

  var mark = root.querySelector('[data-preloader-mark]');
  var flash = root.querySelector('[data-preloader-flash]');
  var imgwrap = root.querySelector('[data-preloader-imgwrap]');
  var img = root.querySelector('[data-preloader-img]');
  var card = root.querySelector('[data-preloader-card]');

  var anims = [];
  var run = function (el, frames, opts) {
    if (!el) return;
    anims.push(el.animate(frames, Object.assign({ duration: D, easing: EASE, fill: 'forwards' }, opts)));
  };

  run(mark, [{ opacity: 0 }, { opacity: 1 }], { delay: 500, easing: 'ease-in' });
  run(flash, [{ clipPath: TOP_EDGE }, { clipPath: FULL }], { delay: 1500 });
  run(imgwrap, [{ clipPath: TOP_EDGE }, { clipPath: FULL }], { delay: 1650 });
  run(img, [{ transform: 'translateY(-30%)' }, { transform: 'translateY(0%)' }], { delay: 1650 });
  run(card, [{ clipPath: FULL }, { clipPath: BOTTOM_EDGE }], { delay: 2650 });
  run(img, [{ transform: 'translateY(0%)' }, { transform: 'translateY(10%)' }], { delay: 2650 });
  run(root, [{ clipPath: FULL }, { clipPath: BOTTOM_EDGE }], { delay: 2950 });

  Promise.all(
    anims.map(function (a) { return a.finished.catch(function () {}); })
  ).then(function () {
    clearTimeout(failsafe);
    finish();
  });
})();
